/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { identity } from 'lodash';

import { Quantity } from '../quantity';
import { DataMapper } from './data-mapper';
import { custom } from './mapper-dsl';

export function createQuantityMapper(config: Hash<TransformFn<any, any>>): DataMapper<Quantity<any>, any> {
  return custom({
    serialize: (q?: Quantity<any>) => q ? (config[q.uomCode] || identity)(q.value) : void 0,
    deserialize: () => {
      throw new Error('QuantityMapper: deserialization is not supported');
    },
  });
}
